import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { HomeIcon, BackIcon } from "@/config/icons";
import { logger } from "@/lib/logger";
import { Button } from "@/components/ui/button";
import { useDocumentHead } from "@/hooks/useDocumentHead";

const NotFound = () => {
  const location = useLocation();

  useDocumentHead({
    title: "Page non trouvée - Luminjo",
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    noindex: true,
  });

  useEffect(() => {
    logger.warn("404 Error: User attempted to access non-existent route", location.pathname, "NotFound");
  }, [location.pathname]);

  return (
    <div className="flex h-screen items-center justify-center bg-muted overflow-auto">
      <motion.div 
        className="text-center px-4 max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <motion.h1 
          className="mb-4 text-8xl font-bold text-primary"
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
        >
          404
        </motion.h1>
        <h2 className="mb-2 text-2xl font-semibold text-foreground">
          Page non trouvée
        </h2>
        <p className="mb-8 text-muted-foreground">
          Oups ! La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link to="/">
              <HomeIcon className="h-4 w-4 mr-2" />
              Retour à l'accueil
            </Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            <BackIcon className="h-4 w-4 mr-2" />
            Page précédente
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
